import { makeStyles } from "@material-ui/core";
import snow from "../../../assets/images/snow.png";

const useStyles = makeStyles((theme: any) => ({
  textSide: {
    width: "27%",
    paddingBottom: "100px",
    position: "absolute",
    zIndex: 22,
    top: "33%",
    left: "4%",
    [theme.breakpoints.down("1300")]: {
      width: "28%",
      "& a": {
        "& img": {
          marginBottom: 30,
        },
      },
      "& h2": {
        fontSize: 32,
        lineHeight: "40px",
      },
      "& p": {
        fontSize: 15,
        margin: "40px 0 30px",
      },
    },
    [theme.breakpoints.down("1100")]: {
      width: "30%",
      "& p": {
        fontSize: 14,
      },
    },
    [theme.breakpoints.down("991")]: {
      width: "32%",
      "& a": {
        "& img": {
          marginBottom: 20,
        },
      },
      "& h2": {
        fontSize: 30,
        lineHeight: "40px",
      },
      "& p": {
        fontSize: 12,
        margin: "30px 0 30px",
      },
    },
    [theme.breakpoints.down("767")]: {
      width: "36%",
      "& a": {
        "& img": {
          marginBottom: 10,
          width: 130,
        },
      },
      "& h2": {
        fontSize: 24,
        lineHeight: "30px",
      },
      "& p": {
        fontSize: 11,
        lineHeight: "26px",
        margin: "20px 0 20px",
      },
    },
    [theme.breakpoints.down("575")]: {
      width: "80%",
      top: "57%",
      "& a": {
        "& img": {
          marginBottom: "25%",
          width: 200,
        },
      },
      "& h2": {
        fontSize: 24,
        lineHeight: "35px",
        color: "#1A364B",
        textAlign: "left",
      },
      "& p": {
        fontSize: 16,
        margin: "20px 0 20px",
        lineHeight: "26px",
        textAlign: "left",
      },
      "& div": {
        textAlign: "center",
        "& img": {
          width: 80,
          height: 80,
          cursor: "pointer",
        },
      },
    },
  },
  image: {
    width: "100%",
    "& img": { maxHeight: "100%", maxWidth: "100%", objectFit: "cover" },
    [theme.breakpoints.down("575")]: {
      paddingBottom: "170px",
    },
  },
  snow: {
    backgroundSize: "cover",
    backgroundImage: `url(${snow})`,
    width: "100%",
    height: "100%",
    position: "absolute",
    animation: "$slideBottom 1s linear infinite",
    zIndex: 1,
  },
  description: {
    fontSize: "20px",
    color: "#245fad",
    margin: "40px 0 55px",
    lineHeight: "33px",
    [theme.breakpoints.down("1730")]: {
      fontSize: 20,
    },
    [theme.breakpoints.down("1600")]: {
      fontSize: 20,
    },
    [theme.breakpoints.down("1500")]: {
      fontSize: 18,
    },
  },
  title: {
    fontSize: "42px",
    lineHeight: "56px",
    color: "#245fad",
  },
  main: {
    position: "relative",
    minHeight: "60vh",
    width: "100%",
    [theme.breakpoints.down("767")]: {
      minHeight: "40vh",
    },
    [theme.breakpoints.down("575")]: {
      minHeight: "30vh",
    },
    [theme.breakpoints.down("430")]: {
      minHeight: "20vh",
    },
  },

  "@keyframes slideBottom": {
    from: { top: -50 },
    to: { top: 20 },
  },
  logo: {
    width: "200px",
    marginBottom: "60px",
  },
  slider: {
    "& .slick-next, .slick-prev": {
      display: "none!important",
    },
    // '& .slick-list': {
    //   padding:'0!important'
    // }
  },
  smallButton: {
    [theme.breakpoints.down("575")]: {
      marginRight: "-35px",
    },
    [theme.breakpoints.down("430")]: {
      marginRight: "-29px",
    },
  },
  bluredCarouselSliderTextArea: {
    backdropFilter: "blur(20.5056px)",
    background:
      "linear-gradient(112.91deg, rgba(255, 255, 255, 0.87) 3.51%, rgba(255, 255, 255, 0.3) 111.71%)",
    boxShadow: "15px 18px 30px rgba(0, 0, 0, 0.05);",
    borderRadius: 24,
    // border: "3px solid white",
    // borderColor:" rgba(255, 255, 255, 0.5) rgba(255, 255, 255, 0.23)",
    // [theme.breakpoints.down('767')]: {
    //   "& .MuiBox-root":{
    //     padding:'17px'
    //   },
    //  },
    [theme.breakpoints.down("767")]: {
      "& .MuiBox-root": {
        padding: "12px 6px",
      },
    },
    [theme.breakpoints.down("575")]: {
      border: "none",
      boxShadow: "none",
      background: "transparent",
      backdropFilter: "none",
      "& .MuiBox-root": {
        padding: "0",
      },
    },
  },
  soundIconArea: {
    position: "absolute",
    right: 0,
    width: "150px",
    height: "150px",
    bottom: 50,
    cursor: "pointer",
    "& img": {
      maxWidth: "100%",
      maxHeight: "100%",
    },
    [theme.breakpoints.down("430")]: {
      width: "100px",
      height: "100px",
      bottom: "40%",
    },
  },
  imageTextArea: {
    position: "absolute",
    top: "5%",
    color: "#225fad",
    fontSize: "28px",
    left: "5%",
    width: "40%",
    "@media (max-width:575px)": {
      fontSize: "16px",
      width: "70%",
    },
  },
}));

export default useStyles;
